module.exports = __webpack_public_path__ + "static/img/layout2.fd4ca6f1.png";